import { useCustomFieldsSchemaQuery } from '../../lib/Queries';
import CustomTag from './CustomTag.jsx';
import { trimEndChar, truncate } from '../../lib/Utils.js';

function getSchemaColorForValue(schema, value) {
    let color = '#FFFFFF';
    if (schema?.options?.length > 1) {
        const opt = schema.options.find(o => o.label === value);

        if (opt) {
            color = opt.color;
        }
    }

    if (schema?.type === 'yesno') {
        return schema?.color;
    }

    return color;
}

const CustomTags = ({
    fields,
    type,
    id,
    className,
    compact,
    excludeFields,
}) => {
    const { data: schemaData, isLoading } = useCustomFieldsSchemaQuery(type);
    const schema = (schemaData || []).filter(
        item => !excludeFields || excludeFields.indexOf(item.key) < 0,
    );

    if (!Array.isArray(schema)) {
        return null;
    }

    // Grab all fields that are supposed to be tags
    const tags = [];
    for (const item of schema) {
        if (item.schema.is_tag && fields && fields[item.key]) {
            if (item.schema?.type === 'yesno') {
                tags.push({
                    schema: item.schema,
                    value: trimEndChar(item.schema.label, '?'),
                });
            } else {
                tags.push({
                    schema: item.schema,
                    value: fields[item.key],
                });
            }
        }
    }

    if (!tags?.length) {
        return null;
    }

    return (
        <div className={`flex items-center space-x-1 flex-wrap ${className}`}>
            {tags.map((tag, idx) => (
                <div key={idx}>
                    <CustomTag
                        compact={compact}
                        value={truncate(tag.value)}
                        color={getSchemaColorForValue(tag.schema, tag.value)}
                    />
                </div>
            ))}
        </div>
    );
};

export default CustomTags;
